import { render, staticRenderFns } from "./position.vue?vue&type=template&id=6219fcd2&"
import script from "./position.vue?vue&type=script&lang=ts&"
export * from "./position.vue?vue&type=script&lang=ts&"
import style0 from "./position.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports